<template>
  <div class="share_bg">
    <img src="../../images/coins_share_bg.jpg" class="share_img_bg"/>
    <div class="list_wrapper">
      <div class="list">
        <div class="list_top">
          <img src="https://jt.weiquaner.com/e/extend/activity/api/images/sg_1514732120000.jpg" class="list_pic" />
          <div class="list_title">元旦快乐</div>
          <div class="list_commend">海报类型：首页</div>
        </div>
        <div class="list_btm">
          <div class="btn_area">
              <div class="submitBtn">
                生成
              </div>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="list_top">
          <img src="https://jt.weiquaner.com/e/extend/activity/api/images/sg_1514732120000.jpg" class="list_pic" />
          <div class="list_title">元旦快乐</div>
          <div class="list_commend">海报类型：首页</div>
        </div>
        <div class="list_btm">
          <div class="btn_area">
              <div class="submitBtn">
                生成
              </div>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="list_top">
          <img src="https://jt.weiquaner.com/e/extend/activity/api/images/sg_1514732120000.jpg" class="list_pic" />
          <div class="list_title">元旦快乐</div>
          <div class="list_commend">海报类型：首页</div>
        </div>
        <div class="list_btm">
          <div class="btn_area">
              <div class="submitBtn">
                生成
              </div>
          </div>
        </div>
      </div>
      <div class="list">
        <div class="list_top">
          <img src="https://jt.weiquaner.com/e/extend/activity/api/images/sg_1514732120000.jpg" class="list_pic" />
          <div class="list_title">元旦快乐</div>
          <div class="list_commend">海报类型：首页</div>
        </div>
        <div class="list_btm">
          <div class="btn_area">
              <div class="submitBtn">
                生成
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"promotePost"
}
</script>

<style lang="stylus">
  .share_bg
    .share_img_bg
      width:750px
      height:280px
    .list_wrapper
      width: 714px
      margin: 0 auto
      font-size: 0px
      position: relative
      font-size:0px
      .list
        width: 343px
        box-sizing: border-box
        background: #fff
        margin:0 7px 20px 7px
        display:inline-block
        .list_top
          padding:0 16px
          .list_pic
            width: 311px
            padding: 18px 0
            height: 311px
          .list_title
            font-size: 28px;
            color: #333;
            display: -webkit-box
            -webkit-box-orient: vertical
            -webkit-line-clamp: 2
            overflow: hidden
          .list_commend
            font-size: 24px
            color:#666
            margin-top: 10px
        .list_btm
          width: 100%
          border-top: 1px solid #f0f0f0
          /*px*/
          margin-top: 20px
          padding: 15px
          box-sizing: border-box
          display: flex
          flex-direction: row
          justify-content: space-around
          .submitBtn
            height: 40px
            line-height: 38px
            font-size:24px
            width:130px
            border: 1px solid #f40
            /*px*/
            background: none
            text-align:center
            color: #f40
</style>



// WEBPACK FOOTER //
// src/components/userCenter/PromotePost.vue